var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareNew = function SvgIconShareNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_share_new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.668 1.921a.66.66 0 0 1 .705.141l6.692 6.612a.61.61 0 0 1 0 .874l-6.692 6.612a.66.66 0 0 1-.705.14.625.625 0 0 1-.401-.578v-3.237c-4.26.13-7.202 1.579-9.344 4.54a.66.66 0 0 1-.781.217.62.62 0 0 1-.38-.696c.492-2.432 1.484-4.904 3.25-6.897 1.682-1.899 4.04-3.335 7.255-3.902V2.5c0-.254.158-.483.4-.579m.89 4.357c0 .31-.236.573-.553.618-3.194.451-5.443 1.794-7.013 3.566-.976 1.102-1.7 2.383-2.22 3.74 2.33-2.036 5.322-2.977 9.14-2.977.356 0 .645.28.645.625v2.341l5.143-5.08-5.142-5.08z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_share_new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconShareNew;